import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseService } from '../../../services/base.service';
import { MeasurementRequest } from '../models/measurement-request';

@Injectable({
  providedIn: 'root'
})
export class MeasurementRequestService extends BaseService<MeasurementRequest> {

  constructor(
    http: HttpClient,
    @Inject('BASE_URL') rootUrl: string        
  ) { 
    super(http,rootUrl,'Plasard/Request');
  }
}
